module.exports = __webpack_public_path__ + "static/media/footerBanner.edefa87b.jpg";